export default {
  pt: {
    'board.board.empty': 'Vazio',
  },
  en: {
    'board.board.empty': 'Empty',
  },
  es: {
    'board.board.empty': 'Vacío',
  },
}
